import { Button, Col, Form, Input, Row, message } from "antd";
import axios from "axios";
import React from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import Footer from "../component/Footer";

const Login = () => {
  const navigate = useNavigate();
  const [, setCookie] = useCookies(["user"]);
  const [, setCookieToken] = useCookies(["accessToken"]);

  const loginUser = async (values) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/user/login`, values);
      // store the user object (includes token) similarly to Google login
      setCookie("user", res?.data);
      // also keep accessToken cookie for compatibility
      setCookieToken("accessToken", res?.data?.token);
      message.success("Đăng nhập thành công!");
      navigate("/");
    } catch (err) {
      message.error("Tài khoản hoặc mật khẩu không đúng!");
    }
  };

  const onFinishFailed = (errorInfo) => {
    message.error("Bạn đang điền thiếu thông tin!");
  };

  const loginGmail = async(credentialResponse) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        { googleId: credentialResponse?.credential },
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      setCookie("user", res?.data);
      message.success("Đăng nhập thành công!");
      navigate("/");
    } catch (err) {
      message.error("Tài khoản hoặc mật khẩu không đúng!");
    }
  };

  return (
    <>
      <div className="h-screen pt-[50px]">
        <div className="mb-[10px]">
          <div className="pt-[20px] text-[40px] text-[var(--red)] flex justify-center">
            Sign in
          </div>
        </div>
        <Row justify={"center"} align={"middle"} style={{ height: "300px" }}>
          <Col lg={14} xs={22} style={{ maxWidth: 380 }}>
            <Form
              onFinish={loginUser}
              onFinishFailed={onFinishFailed}
              name="basic"
              layout={"vertical"}
              colon={false}>
              <Form.Item name="email">
                <Input
                  className="!rounded-none p-[10px]"
                  size={"large"}
                  placeholder="Login"
                />
              </Form.Item>
              <Form.Item name="password" className="mt-[-6px]">
                <Input.Password
                  className="!rounded-none p-[10px]"
                  size={"large"}
                  placeholder="Password"
                />
              </Form.Item>
              <Button
                style={{
                  background: "white",
                  width: "100%",
                  height: 40,
                  marginTop: 10
                }}
                size={"large"}
                htmlType="submit"
                shape="round"
              >
                <span className="font-semibold text-lg">Log in</span>
              </Button>

              <div className="mt-4 flex justify-center">
                <GoogleOAuthProvider clientId="253239939416-cv56na10g3t9trr8jaij772bv2frh7u0.apps.googleusercontent.com">
                  <GoogleLogin
                    onSuccess={loginGmail}
                    onError={(err)=>console.log(err)}
                    shape="pill"
                    theme="outline"
                    size="large"
                    width={"380px"}
                  />
                </GoogleOAuthProvider>
              </div>
            </Form>
          </Col>
        </Row>
      </div>
      {Footer()}
    </>
  );
};

export default Login;
